import styled from '@emotion/styled'
import { HeaderPillStyled } from './Header.styles'

export const NoveltyListStyled = styled.dl({
  margin: '1rem 0 0',
  '&::after': {
    clear: 'both',
    content: "''",
    display: 'table',
  },
})

export const NoveltyPlaceStyled = styled.dt({
  marginBottom: '0.5rem',
  marginLeft: 0,
  width: '7rem',
  clear: 'both',
  float: 'left',

  '&:last-of-type': {
    marginBottom: 0,
  },
})

export const NoveltyStarterStyled = styled.dd({
  marginBottom: '0.5rem',
  marginLeft: 0,
  width: 'calc(100% - 7rem)',
  clear: 'none',
  float: 'right',
  wordBreak: 'break-all',
  whiteSpace: 'normal',

  '&:last-of-type': { marginBottom: 0 },
})

export const NoveltyPlacePillStyled = styled(HeaderPillStyled)({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
  marginLeft: '-0.7rem',
  minWidth: '2rem', // so that `1st`, `2nd`, `3rd`, and `4th` pills all have the same width
})

export const NoveltyPlaceTextStyled = styled.span({
  fontSize: '1.2rem',
})
